export default "__VITE_ASSET__DWot9ao$__"